import { useSelector } from 'react-redux';
import { SelectCurrentProjectConfig } from './projectConfig/ProjectConfigSelectors';

export const useCurrentProjectConfig = () => useSelector(SelectCurrentProjectConfig);
